import { render, staticRenderFns } from "./HelpFAQ.vue?vue&type=template&id=4fd575b0&scoped=true"
import script from "./HelpFAQ.vue?vue&type=script&lang=js"
export * from "./HelpFAQ.vue?vue&type=script&lang=js"
import style0 from "./HelpFAQ.vue?vue&type=style&index=0&id=4fd575b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd575b0",
  null
  
)

export default component.exports